import React from "react";
import LegalLayout from "./LegalLayout";

const LegalInfo = () => (
  <LegalLayout title="Información legal y de contacto">
    <div className="legal-data">
      <p><strong>Nombre comercial:</strong> VPEX</p>
      <p><strong>Administrador y titular:</strong> Valentin Alvarez</p>
      <p><strong>Documento:</strong> CI 52879776</p>
      <p><strong>País:</strong> Uruguay</p>
      <p><strong>Sitio web:</strong> vpex.com.uy</p>
      <p><strong>Correo electrónico:</strong> <a href="mailto:valvarez@vpex.com.uy">valvarez@vpex.com.uy</a></p>
      <p><strong>Teléfono y WhatsApp:</strong> <a href="tel:+59899447449">+598 99 447 449</a></p>
    </div>
    <h2>Canales de atención</h2>
    <p>Las consultas pueden realizarse mediante el formulario de contacto del sitio, correo electrónico o WhatsApp. VPEX opera desde Uruguay y presta servicios digitales de forma remota.</p>
  </LegalLayout>
);
export default LegalInfo;
